import styled, {css} from 'styled-components'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Button} from '@/components/ui/button/Button'

export const StyledNotificationItem = styled(Flexbox)<{$isAlert?: boolean}>(({theme: {palette, spacing}, $isAlert}) => {
    const backgroundColor = $isAlert ? palette.orange['100'] : palette.neutral.white
    // The alert background must stay as-is on hover — only the neutral/white state
    // gets the neutral['50'] hover treatment.
    const hoverBackgroundColor = $isAlert ? backgroundColor : palette.neutral['50']

    return `
        padding: ${spacing * 4}px;
        cursor: pointer;
        transition: background-color 0.2s ease-in-out;
        background-color: ${backgroundColor};
        &:hover {
            background-color: ${hoverBackgroundColor};
        }

    `
})

export const StyledNotificationTime = styled.span(
    ({theme: {typography, palette}}) => `
        ${typography.textXs};
        color: ${palette.neutral['500']};
    `
)

// The "primary" variant (unread state, "Segna come letto") uses the theme's
// primary/600 by default — override it to match StyledNotificationUnreadDot's
// color (primary/500, #3b82f6) at rest, hover and press alike.
export const StyledMarkReadButton = styled(Button)`
    ${({variant}) =>
        variant === 'primary' &&
        css`
            background: #3b82f6 !important;

            &:hover {
                background: #3b82f6 !important;
            }

            &:active,
            &.active {
                background: #3b82f6 !important;
            }
        `}
`

export const StyledNotificationUnreadDot = styled.div(
    ({theme: {palette}}) => `
        min-width: 8px;
        width: 8px;
        height: 8px;
        background-color: ${palette.primary['500']};
        border-radius: 50%;
    `
)
